import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { format } from 'date-fns';
import { BehaviorSubject, combineLatest, map, shareReplay } from 'rxjs';
import { TranslationKeyTranslation } from 'server/shared/models/translation';
import { PoolerUser } from 'server/shared/models/user';
import { TranslationService } from '../../services/translation.service';

@Component({
  selector: 'app-monthly-working-hours',
  templateUrl: './monthly-working-hours.component.html',
  styleUrls: ['./monthly-working-hours.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MonthlyWorkingHoursComponent {
  user$ = new BehaviorSubject<PoolerUser | undefined>(undefined);
  @Input() set user(value: PoolerUser | undefined) {
    this.user$.next(value);
  }
  get user() {
    return this.user$.value;
  }

  customerId$ = new BehaviorSubject<string | undefined>(undefined);
  @Input() set customerId(value: string | undefined) {
    this.customerId$.next(value);
  }
  get customerId() {
    return this.customerId$.value;
  }

  jobDate$ = new BehaviorSubject<string | undefined>(undefined);
  @Input() set jobDate(value: string | undefined) {
    this.jobDate$.next(value);
  }
  get jobDate() {
    return this.jobDate$.value;
  }

  i18n?: TranslationKeyTranslation =
    this.translationService.getTranslations('jobs');

  tooltip = '';

  percentage$ = combineLatest([
    this.user$,
    this.customerId$,
    this.jobDate$,
  ]).pipe(
    map(([user, customerId, jobDate]) => {
      if (
        !jobDate ||
        !customerId ||
        !user?.customerInformation?.[customerId]?.monthlyHours
      ) {
        return 0;
      }
      let total = user.customerInformation[customerId].monthlyHours || 0;
      let current =
        user.customerInformation[customerId].monthlyWorkingHours?.[
          format(new Date(jobDate), 'yyyy-MM')
        ]?.total || 0;

      let percentage = Math.round((current / total) * 100 * 10) / 10;

      this.tooltip =
        this.i18n?.monthlyWorkingHoursTooltip
          ?.replace('{{percentage}}', percentage.toString())
          .replace('{{current}}', current.toString())
          .replace('{{total}}', total.toString()) || '';

      return Math.round(percentage);
    }),
    shareReplay(1),
  );

  constructor(private translationService: TranslationService) {}
}
